const LANGUAGES = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Español' },
};

export default LANGUAGES;
